<template>
  <div>
    <form
      autocomplete="off"
      class="form-input relative"
      v-on:submit="handleSearchSubmit"
    >
      <div class="search-input">
        <div class="dsr-search-box" id="search-box-area">
          <div class="flex flex-auto">
            <div class="search-input w-full relative mb-3">
              <input
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                autofocus
                class="input-text-1"
                id="search-box-input"
                placeholder="Search"
                type="text"
                v-model="query"
                v-on:input="autoSearchTerms"
              />
              <div
                class="clear-search mr-8"
                v-if="shouldDisplaySearchClear"
                v-on:click="clearSearch"
              >
                <close></close>
              </div>
              <div class="absolute right-0 top-0 mt-1 text-gray-400">
                <Zondicon
                  class="nav-icon w-6 fill-current cursor-pointer ml-3"
                  icon="Search"
                  v-on:click="handleSearchSubmit"
                />
              </div>
            </div>
            <div>
              <span title="Filter by category" v-on:click="toggleCategories">
                <Zondicon
                  class="nav-icon w-8 fill-current cursor-pointer ml-3"
                  icon="FilterIcon"
                />
              </span>
            </div>
          </div>

          <div class="relative" style="top: -12px" v-if="showCategories">
            <div
              class="search__dropdown absolute w-full bg-white border-r border-l z-10"
              id="suggestions"
            >
              <div
                class="absolute right-0 p-2"
                v-on:click="showCategories = false"
              >
                <close></close>
              </div>

              <div>
                <div
                  :key="term.name"
                  class="search-term-item px-3 py-2 cursor-pointer border-b"
                  v-for="term in admin_book_search_terms"
                  v-on:click="handleTermClick(term)"
                >
                  <span
                    class="search-term-item-value"
                    v-html="term.name"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- #search-box-area -->
      </div>
      <!-- .search-input -->
    </form>
    <div v-if="$route.name === 'NotesSearch'">
      <span
        class="px-3 py-1 cursor-pointer"
        title="Author"
        v-if="author"
        v-on:click="clearAuthor"
      >
        <Zondicon
          class="inline-block w-3 fill-current cursor-pointer mr-1 mb-1"
          icon="Close"
        />{{ author.name }}
      </span>
      <span
        class="px-3 py-1 cursor-pointer"
        title="Notebook"
        v-if="book"
        v-on:click="clearBook"
      >
        <Zondicon
          class="inline-block w-3 fill-current cursor-pointer mr-1 mb-1"
          icon="Close"
        />{{ book.name }}
      </span>
      <span
        class="px-3 py-1 cursor-pointer"
        v-if="$route.query.category"
        v-on:click="clearFilters"
      >
        <Zondicon
          class="inline-block w-3 fill-current cursor-pointer mr-1 mb-1"
          icon="Close"
        />clear categories
      </span>
    </div>
  </div>
</template>

<script>
import { API_URL } from "../env.js";
import Close from "./ui/Close.vue";
import axios from 'axios';

export default {
  data() {
    return {
      searchTerms: [],
      isSearching: false,
      query: "",
      showCategories: false
    };
  },
  components: {
    Close
  },
  // props: ['handleSearchSubmit'],
  computed: {
    noResults() {
      return !this.hasRetrievedTerms;
    },
    hasRetrievedTerms() {
      return this.admin_book_search_terms.length > 0;
    },
    book() {
      return this.$store.state.notes.book;
    },
    admin_book_search_terms() {
      return this.$store.state.notes.admin_book_search_terms;
    },
    shouldDisplaySearchClear() {
      return (
        this.query !== "" ||
        (this.$route.query.query && this.$route.query.query !== "")
      );
    },
    author() {
      return this.$store.state.notes.author;
    }
  },
  // mounted() {
  //     // If the user clicks outside of the search-box-area, close the suggestions
  //     let searchBoxArea = document.getElementById("search-box-area");
  //
  //     searchBoxArea.addEventListener("click", function (e) {
  //         e.stopPropagation();// this will stop propagation of this event to upper level
  //     });
  //
  //     document.body.addEventListener("click", this.handleOutsideClick);
  // },
  // beforeDestroy() {
  //     document.body.removeEventListener("click", this.handleOutsideClick);
  // },
  mounted() {
    // If the user clicks outside of the recent-notes, close the suggestions
    let searchBoxArea = document.getElementById("search-box-area");
    searchBoxArea.addEventListener("click", this.handleInsideClick);
    document.body.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    handleInsideClick(e) {
      e.stopPropagation(); // this will stop propagation of this event to upper level
    },
    handleOutsideClick(e) {
      console.log("public search");
      this.$store.dispatch("aShowSearch", { show: false, closeOthers: false });
    },
    clearAuthor() {
      let search = Object.assign({}, this.$route.query);
      delete search["user"];
      this.$router.push({ path: `/notes/search`, query: search });
    },
    clearBook() {
      let search = Object.assign({}, this.$route.query);
      delete search["book"];
      this.$router.push({ path: `/notes/search`, query: search });
    },
    clearFilters() {
      let search = Object.assign({}, this.$route.query);
      delete search["category"];
      this.$router.push({ path: `/notes/search`, query: search });
    },
    handleSearchSubmit(e) {
      e.preventDefault();
      let search = Object.assign({}, this.$route.query);
      search.query = this.query;
      if (this.author) {
        search.user = this.author.id;
      }
      if (this.book) {
        search.book = this.book.id;
      }
      // if (this.$route.params.user) {
      //     search.user = this.$route.params.user;
      // }
      // if (this.$route.params.book) {
      //     search.book = this.$route.params.book;
      // }
      if (this.$route.query.category) {
        search.category = this.$route.query.category;
      }
      delete search["page"];
      this.$router.push({ path: `/notes/search`, query: search });
      this.isSearching = false;
    },
    clearSearch: function(e) {
      e.preventDefault();
      // Clear the text or reset the whole search
      if (this.query === "") {
        let search = Object.assign({}, this.$route.query);
        delete search["page"];
        delete search["category"];
        delete search["query"];
        this.$router.push({ path: this.$route.path, query: search });
      } else {
        this.query = "";
      }
      this.isSearching = false;
      const clearingSearch = true;
    },

    handleTermClick: function(term) {
      let search = Object.assign({}, this.$route.query);
      if (this.author) {
        search.user = this.author.id;
      }
      if (this.book) {
        search.book = this.book.id;
      }
      // if (this.$route.params.user) {
      //     search.user = this.$route.params.user;
      // }
      // if (this.$route.params.book) {
      //     search.book = this.$route.params.book;
      // }
      search.category = term.slug;
      delete search["page"];
      this.$router.push({ path: `/notes/search`, query: search });
      this.$store.dispatch("aShowSearch", { show: false, closeOthers: false });
      this.isSearching = false;
    },

    handleInputSearch: function(e) {
      const query = e.target.value;
      this.handleSearch(query);
    },

    autoSearchTerms() {
      if (this.query.length % 3 === 0) {
        this.handleSearch(this.query);
      }
    },

    handleSearch: function(query) {
      // if the query is blank, don't search
      if (query === "") {
        this.isSearching = false;
        this.searchTerms = [];
        return;
      }

      let uri = API_URL + "/terms/search?query=" + query;
      this.axios.get(uri).then(res => {
        this.searchTerms = res.data;
        this.isSearching = true;
      });

      this.isSearching = true;

      // The Search button needs the query text, so
      // I need to make the query available to this component and the search bar
      // this.props.handleSearch(query);
    },

    toggleCategories() {
      this.showCategories = !this.showCategories;
      console.log('toggle catego', this.showCategories);
      if (this.showCategories) {
        this.getCategories();
      }
    },

    getCategories() {
      console.log('getting cats');
      let queryParams = "";
      if (this.author) {
        queryParams += "user=" + this.author.id;
      }
      if (this.book) {
        queryParams += "&book=" + this.book.id;
      }
      // if (this.$route.params.user) {
      //     queryParams += 'user=' + this.$route.params.user;
      // }
      // if (this.$route.params.book) {
      //     queryParams += '&book=' + this.$route.params.book;
      // }
      let uri = `${API_URL}/terms/search?${queryParams}`;
      axios.get(uri, this.$store.getters.authHeaders).then(res => {
        this.$store.dispatch("aSetAdminBookSearchTerms", res.data);
        this.isSearching = true;
      });
    },

    stopSearching: function() {
      this.isSearching = false;
    }
  }
};
</script>

<style lang="scss">
.clear-search {
  position: absolute;
  padding: 9px;
  z-index: 1;
  right: 5px;
  top: 0px;
}

.clear-search svg {
  fill: #aaa;

  cursor: pointer;
}

.clear-search svg:hover {
  fill: #700;
}

.page .clear-search {
  right: 0px;
  padding: 15px;
}

@media (min-width: 768px) {
  // On Desktop, move the icons (X button on search and
  // marker for location) back in position.
  .clear-search {
    right: 8px;
  }
}

.terms-search .close {
  right: 0px;
  position: absolute;
  padding: 10px;
  cursor: pointer;
}

.clear-search {
  position: absolute;
  padding: 9px;
  z-index: 1;
  right: 5px;
  top: 0px;
}

.clear-search svg {
  fill: #aaa;

  cursor: pointer;
}

.clear-search svg:hover {
  fill: #700;
}

.page .clear-search {
  right: 0px;
  padding: 15px;
}

@media (min-width: 768px) {
  // On Desktop, move the icons (X button on search and
  // marker for location) back in position.
  .clear-search {
    right: 8px;
  }
}

.terms-search .close {
  right: 0px;
  position: absolute;
  padding: 10px;
  cursor: pointer;
}
</style>
